import type { JSX } from 'react';
import React from 'react';

import { useFlags } from '@feathr/extender/state';
import { isImportsRevampEnabled } from '@feathr/extender/utils/importsRevampFlags';

import type { IImportersAlertProps } from './ImportersAlert.types';
import LegacyImportersAlert from './LegacyImportersAlert';
import PolledImportersAlert from './PolledImportersAlert';

function ImportersAlert(props: Readonly<IImportersAlertProps>): JSX.Element {
  return isImportsRevampEnabled(useFlags()) ? (
    <PolledImportersAlert {...props} />
  ) : (
    <LegacyImportersAlert {...props} />
  );
}

export default ImportersAlert;
